module.exports = __webpack_public_path__ + "img/1.18059675.jpg";